import {
  ForgotPasswordActionTypes,
  FORGOT_PASSWORD_FAIL,
  FORGOT_PASSWORD_LOADING,
  FORGOT_PASSWORD_SUCCESS,
  ForgotPasswordState,
  FORGOT_PASSWORD_UPDATE_API_MSG,
  FORGOT_PASSWORD_UPDATE_API_RES,
} from "./ActionTypes";
import { forgotPasswordValue } from "./Model";

const initialStateGetPosts: ForgotPasswordState = {
  loading: false,
  ForgotPasswordRes: {} as forgotPasswordValue,
  successMsg: "",
  errorMsg: "",
  status: 0,
};
export const forgotPasswordReducer = (
  state = initialStateGetPosts,
  action: ForgotPasswordActionTypes
): ForgotPasswordState => {
  switch (action.type) {
    case FORGOT_PASSWORD_LOADING:
      return {
        ...state,
        loading: action.loading,
      };
    case FORGOT_PASSWORD_SUCCESS:
      return {
        ...state,
        ForgotPasswordRes: action.payload,
        successMsg: action.successMsg,
      };
    case FORGOT_PASSWORD_FAIL:
      return {
        ...state,
        ForgotPasswordRes: action.payload,
        errorMsg: action.errorMsg,
        status: action.status,
      };
    case FORGOT_PASSWORD_UPDATE_API_MSG:
      return {
        ...state,
        ForgotPasswordRes: action.payload,
        successMsg: action.successMsg,
        errorMsg: action.errorMsg,
        status: action.status,
      };
    case FORGOT_PASSWORD_UPDATE_API_RES:
      return {
        ...state,
        ForgotPasswordRes: action.payload,
        successMsg: action.successMsg,
        errorMsg: action.errorMsg,
        status: action.status,
      };
    default:
      return state;
  }
};

